import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type DRILLDOWN_STATES} from 'web-app/react/child-development/child-development-drilldown-switcher/constants';

const domain = 'MODALS/CHILD_DEVELOPMENT_DRILLDOWN';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (
        childId: string,
        mode: DRILLDOWN_STATES,
        subAreaId?: string,
        ageBandId?: string,
        refetchQueries?: any,
        disallowLinks?: boolean,
    ) => ({childId, mode, subAreaId, ageBandId, refetchQueries, disallowLinks}),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
